import contractComponent from './contract.component';
import ContractCreate from './create'
import ContractEdit from './edit'
import ContractAll from './all'

let contractModule = angular.module('contract', [
  ContractCreate,
  ContractEdit,
  ContractAll
])

  .component('contract', contractComponent)

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $stateProvider
      .state('contract.edit', {
        url: '/edit/:id',
        component: 'contractedit',
        data: {
          requireACL: 'tnt_billing_contract.edit'
        }
      })

      .state('contract.create', {
        url: '/create',
        component: 'contractcreate',
        data: {
          requireACL: 'tnt_billing_contract.create'
        }
      })

      .state('contract.all', {
        url: '/all/:page',
        component: 'contractall',
        data: {
          requireACL: 'tnt_billing_contract.view'
        }
      })

      .state('contract.edit.print_history', {
        url: '/print-contract-rules-update-history',
        component: 'printhistory',
        data: {
          requireACL: 'tnt_billing_contract.edit'
        }
      })
  })

  .name;

export default contractModule;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/contract/index.js